<template>
    <div class="container-main" v-if="galleryVideo">
        <video playsinline autoplay muted loop>
            <source :src="galleryVideo.videos_url" type="video/mp4" />
        </video>
        <div>
            <img class="imge" src="/wave-white.svg" alt="" style="width: 100%;  top: 66%;">
        </div>
        <div >
            <div class=" d-flex align-items-end">
                <img class="fondo imge" src="/metaHorizontalAzul.png"  alt="">
            </div>
        </div>
    </div>      
</template>

<script>
export default {
  name: "video",
  data() {
    return {
        galleryVideo:undefined,
    };
  },
  created() {
    this.plain
    .get(`/galleriesName?title=Video`)
    .then((response) => {
      this.galleryVideo= response.data
      // console.log(response);
      })
      .catch((err) => {
      this.galleryVideo = undefined;
      console.log(err);
    })
  },
};
</script>

<style scoped>
/* 
---------------------------------------------
banner
--------------------------------------------- 
*/
.container-main{
    width: 100%;
    height: 100%;
    position: relative;
    margin-bottom: 10%;
}
.container-main video{
    width: 100%;
    height: 100%;
    display: block;
}

.container-main .imge{
    position: absolute;
}
.fondo{
    width: 33%;
    top: 90%;
    margin-left: 2%;
}

</style>